import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ChevronLeft, MessageSquare } from 'lucide-react';
import { Button } from '../../components/ui/button';
import WhatsAppSettings from './components/WhatsAppSettings';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AIActorWhatsAppSettings() {
  const { actorId } = useParams();
  const navigate = useNavigate();
  const [actor, setActor] = useState(null);

  useEffect(() => {
    loadActor();
  }, [actorId]);

  const loadActor = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/api/ai/actors/${actorId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setActor(response.data);
    } catch (err) {
      console.error('Error loading actor:', err);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-white border-b">
        <div className="container max-w-5xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate(`/ai/actors/${actorId}/manage`)}
              >
                <ChevronLeft className="w-4 h-4 mr-1" />
                Back to Manage
              </Button>
              <div>
                <h1 className="text-2xl font-bold flex items-center gap-2">
                  <MessageSquare className="w-6 h-6 text-green-600" />
                  WhatsApp Settings
                </h1>
                <p className="text-sm text-muted-foreground">
                  {actor?.name || 'Loading...'}
                </p>
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate(`/ai/actors/${actorId}/whatsapp`)}
            >
              <MessageSquare className="w-4 h-4 mr-2" />
              View Inbox
            </Button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container max-w-5xl mx-auto px-6 py-8">
        <WhatsAppSettings actorId={actorId} />
      </div>
    </div>
  );
}
